/** From the public folder rather than inline JSX, for a smaller bundle and browser-cached SVGs. */
export function SdgIcon(props: { goal: number; className?: string }) {
	if (props.goal < 1 || props.goal > 17) return null;
	return <img src={`/sdgs/${props.goal}.svg`} alt="" width={40} height={40} className={props.className} />;
}
